/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SplatRouteImport } from './routes/$'
import { Route as ProtectedRouteImport } from './routes/_protected'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as open403RouteImport } from './routes/(open)/403'
import { Route as open404RouteImport } from './routes/(open)/404'
import { Route as open500RouteImport } from './routes/(open)/500'
import { Route as openCompanyInvitationRouteImport } from './routes/(open)/company-invitation'
import { Route as openPreviewAccessDeniedRouteImport } from './routes/(open)/preview-access-denied'
import { Route as ProtectedAccountRouteImport } from './routes/_protected/account'
import { Route as ProtectedHelpRouteImport } from './routes/_protected/help'
import { Route as ProtectedHomeRouteImport } from './routes/_protected/home'
import { Route as ProtectedMembersRouteImport } from './routes/_protected/members'
import { Route as ProtectedMyProjectsRouteImport } from './routes/_protected/my-projects'
import { Route as ProtectedOficinas3rRouteImport } from './routes/_protected/oficinas3r'
import { Route as ProtectedOnboardingRouteImport } from './routes/_protected/onboarding'
import { Route as ProtectedSlaRouteImport } from './routes/_protected/sla'
import { Route as ProtectedTrilhaDeMetricasRouteImport } from './routes/_protected/trilha-de-metricas'
import { Route as PublicForgotPasswordRouteImport } from './routes/_public/forgot-password'
import { Route as PublicSignInRouteImport } from './routes/_public/sign-in'
import { Route as PublicSignUpRouteImport } from './routes/_public/sign-up'
import { Route as PublicTwoFactorAuthenticationRouteImport } from './routes/_public/two-factor-authentication'
import { Route as openAnswerSurveyIdRouteImport } from './routes/(open)/answer/$surveyId'
import { Route as ProtectedadminAdministratorRouteImport } from './routes/_protected/(admin)/administrator'
import { Route as ProtectedadminCompanyRouteImport } from './routes/_protected/(admin)/company'
import { Route as ProtectedadminQuestionsRouteImport } from './routes/_protected/(admin)/questions'
import { Route as ProtectedadminThemesRouteImport } from './routes/_protected/(admin)/themes'
import { Route as ProtectedadminUserRouteImport } from './routes/_protected/(admin)/user'
import { Route as ProtectedProjectReportsProjectIdRouteImport } from './routes/_protected/project-reports/$projectId'
import { Route as ProtectedProjectsProjectIdRouteImport } from './routes/_protected/projects/$projectId'
import { Route as PublicResetPasswordResetPasswordAccessTokenRouteImport } from './routes/_public/reset-password/$resetPasswordAccessToken'
import { Route as PublicSignInEmailRouteImport } from './routes/_public/sign-in_.email'
import { Route as ProtectedadminListProjectsCompanyIdRouteImport } from './routes/_protected/(admin)/list-projects/$companyId'
import { Route as ProtectedadminMembersCompanyIdRouteImport } from './routes/_protected/(admin)/members/$companyId'
import { Route as ProtectedadminNewProjectIdRouteImport } from './routes/_protected/(admin)/new-project/$id'
import { Route as ProtectedadminQuestionNewRouteImport } from './routes/_protected/(admin)/question/new'
import { Route as ProtectedadminThemeNewRouteImport } from './routes/_protected/(admin)/theme/new'
import { Route as ProtectedAnswerSurveyIdPreviewRouteImport } from './routes/_protected/answer/$surveyId/preview'
import { Route as PublicAuthProviderCompleteRouteImport } from './routes/_public/auth/provider/complete'
import { Route as PublicSignInEmailCodeRouteImport } from './routes/_public/sign-in_.email_.code'
import { Route as ProtectedadminCompanyDetailIdRouteImport } from './routes/_protected/(admin)/company/detail/$id'
import { Route as ProtectedadminProjectsProjectIdCompanyIdRouteImport } from './routes/_protected/(admin)/projects/$projectId/$companyId'
import { Route as ProtectedadminQuestionDetailQuestionIdRouteImport } from './routes/_protected/(admin)/question/detail/$questionId'
import { Route as ProtectedadminThemeThemeIdModelsRouteImport } from './routes/_protected/(admin)/theme/$themeId/models'
import { Route as ProtectedadminThemeDetailThemeIdRouteImport } from './routes/_protected/(admin)/theme/detail/$themeId'
import { Route as ProtectedadminUserDetailIdRouteImport } from './routes/_protected/(admin)/user/detail/$id'
import { Route as ProtectedadminThemeThemeIdModelsNewRouteImport } from './routes/_protected/(admin)/theme/$themeId/models/new'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SplatRoute = SplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => rootRouteImport,
} as any)
const ProtectedRoute = ProtectedRouteImport.update({
  id: '/_protected',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicRoute = PublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const open403Route = open403RouteImport.update({
  id: '/(open)/403',
  path: '/403',
  getParentRoute: () => rootRouteImport,
} as any)
const open404Route = open404RouteImport.update({
  id: '/(open)/404',
  path: '/404',
  getParentRoute: () => rootRouteImport,
} as any)
const open500Route = open500RouteImport.update({
  id: '/(open)/500',
  path: '/500',
  getParentRoute: () => rootRouteImport,
} as any)
const openCompanyInvitationRoute = openCompanyInvitationRouteImport.update({
  id: '/(open)/company-invitation',
  path: '/company-invitation',
  getParentRoute: () => rootRouteImport,
} as any)
const openPreviewAccessDeniedRoute = openPreviewAccessDeniedRouteImport.update({
  id: '/(open)/preview-access-denied',
  path: '/preview-access-denied',
  getParentRoute: () => rootRouteImport,
} as any)
const ProtectedAccountRoute = ProtectedAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedHelpRoute = ProtectedHelpRouteImport.update({
  id: '/help',
  path: '/help',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedHomeRoute = ProtectedHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedMembersRoute = ProtectedMembersRouteImport.update({
  id: '/members',
  path: '/members',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedMyProjectsRoute = ProtectedMyProjectsRouteImport.update({
  id: '/my-projects',
  path: '/my-projects',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedOficinas3rRoute = ProtectedOficinas3rRouteImport.update({
  id: '/oficinas3r',
  path: '/oficinas3r',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedOnboardingRoute = ProtectedOnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedSlaRoute = ProtectedSlaRouteImport.update({
  id: '/sla',
  path: '/sla',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedTrilhaDeMetricasRoute =
  ProtectedTrilhaDeMetricasRouteImport.update({
    id: '/trilha-de-metricas',
    path: '/trilha-de-metricas',
    getParentRoute: () => ProtectedRoute,
  } as any)
const PublicForgotPasswordRoute = PublicForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => PublicRoute,
} as any)
const PublicSignInRoute = PublicSignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => PublicRoute,
} as any)
const PublicSignUpRoute = PublicSignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => PublicRoute,
} as any)
const PublicTwoFactorAuthenticationRoute =
  PublicTwoFactorAuthenticationRouteImport.update({
    id: '/two-factor-authentication',
    path: '/two-factor-authentication',
    getParentRoute: () => PublicRoute,
  } as any)
const openAnswerSurveyIdRoute = openAnswerSurveyIdRouteImport.update({
  id: '/(open)/answer/$surveyId',
  path: '/answer/$surveyId',
  getParentRoute: () => rootRouteImport,
} as any)
const ProtectedadminAdministratorRoute =
  ProtectedadminAdministratorRouteImport.update({
    id: '/(admin)/administrator',
    path: '/administrator',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedadminCompanyRoute = ProtectedadminCompanyRouteImport.update({
  id: '/(admin)/company',
  path: '/company',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedadminQuestionsRoute = ProtectedadminQuestionsRouteImport.update({
  id: '/(admin)/questions',
  path: '/questions',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedadminThemesRoute = ProtectedadminThemesRouteImport.update({
  id: '/(admin)/themes',
  path: '/themes',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedadminUserRoute = ProtectedadminUserRouteImport.update({
  id: '/(admin)/user',
  path: '/user',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedProjectReportsProjectIdRoute =
  ProtectedProjectReportsProjectIdRouteImport.update({
    id: '/project-reports/$projectId',
    path: '/project-reports/$projectId',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedProjectsProjectIdRoute =
  ProtectedProjectsProjectIdRouteImport.update({
    id: '/projects/$projectId',
    path: '/projects/$projectId',
    getParentRoute: () => ProtectedRoute,
  } as any)
const PublicResetPasswordResetPasswordAccessTokenRoute =
  PublicResetPasswordResetPasswordAccessTokenRouteImport.update({
    id: '/reset-password/$resetPasswordAccessToken',
    path: '/reset-password/$resetPasswordAccessToken',
    getParentRoute: () => PublicRoute,
  } as any)
const PublicSignInEmailRoute = PublicSignInEmailRouteImport.update({
  id: '/sign-in_/email',
  path: '/sign-in/email',
  getParentRoute: () => PublicRoute,
} as any)
const ProtectedadminListProjectsCompanyIdRoute =
  ProtectedadminListProjectsCompanyIdRouteImport.update({
    id: '/(admin)/list-projects/$companyId',
    path: '/list-projects/$companyId',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedadminMembersCompanyIdRoute =
  ProtectedadminMembersCompanyIdRouteImport.update({
    id: '/(admin)/members/$companyId',
    path: '/members/$companyId',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedadminNewProjectIdRoute =
  ProtectedadminNewProjectIdRouteImport.update({
    id: '/(admin)/new-project/$id',
    path: '/new-project/$id',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedadminQuestionNewRoute =
  ProtectedadminQuestionNewRouteImport.update({
    id: '/(admin)/question/new',
    path: '/question/new',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedadminThemeNewRoute = ProtectedadminThemeNewRouteImport.update({
  id: '/(admin)/theme/new',
  path: '/theme/new',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedAnswerSurveyIdPreviewRoute =
  ProtectedAnswerSurveyIdPreviewRouteImport.update({
    id: '/answer/$surveyId/preview',
    path: '/answer/$surveyId/preview',
    getParentRoute: () => ProtectedRoute,
  } as any)
const PublicAuthProviderCompleteRoute =
  PublicAuthProviderCompleteRouteImport.update({
    id: '/auth/provider/complete',
    path: '/auth/provider/complete',
    getParentRoute: () => PublicRoute,
  } as any)
const PublicSignInEmailCodeRoute = PublicSignInEmailCodeRouteImport.update({
  id: '/sign-in_/email_/code',
  path: '/sign-in/email/code',
  getParentRoute: () => PublicRoute,
} as any)
const ProtectedadminCompanyDetailIdRoute =
  ProtectedadminCompanyDetailIdRouteImport.update({
    id: '/detail/$id',
    path: '/detail/$id',
    getParentRoute: () => ProtectedadminCompanyRoute,
  } as any)
const ProtectedadminProjectsProjectIdCompanyIdRoute =
  ProtectedadminProjectsProjectIdCompanyIdRouteImport.update({
    id: '/(admin)/projects/$projectId/$companyId',
    path: '/projects/$projectId/$companyId',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedadminQuestionDetailQuestionIdRoute =
  ProtectedadminQuestionDetailQuestionIdRouteImport.update({
    id: '/(admin)/question/detail/$questionId',
    path: '/question/detail/$questionId',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedadminThemeThemeIdModelsRoute =
  ProtectedadminThemeThemeIdModelsRouteImport.update({
    id: '/(admin)/theme/$themeId/models',
    path: '/theme/$themeId/models',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedadminThemeDetailThemeIdRoute =
  ProtectedadminThemeDetailThemeIdRouteImport.update({
    id: '/(admin)/theme/detail/$themeId',
    path: '/theme/detail/$themeId',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedadminUserDetailIdRoute =
  ProtectedadminUserDetailIdRouteImport.update({
    id: '/detail/$id',
    path: '/detail/$id',
    getParentRoute: () => ProtectedadminUserRoute,
  } as any)
const ProtectedadminThemeThemeIdModelsNewRoute =
  ProtectedadminThemeThemeIdModelsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => ProtectedadminThemeThemeIdModelsRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/403': typeof open403Route
  '/404': typeof open404Route
  '/500': typeof open500Route
  '/company-invitation': typeof openCompanyInvitationRoute
  '/preview-access-denied': typeof openPreviewAccessDeniedRoute
  '/account': typeof ProtectedAccountRoute
  '/help': typeof ProtectedHelpRoute
  '/home': typeof ProtectedHomeRoute
  '/members': typeof ProtectedMembersRoute
  '/my-projects': typeof ProtectedMyProjectsRoute
  '/oficinas3r': typeof ProtectedOficinas3rRoute
  '/onboarding': typeof ProtectedOnboardingRoute
  '/sla': typeof ProtectedSlaRoute
  '/trilha-de-metricas': typeof ProtectedTrilhaDeMetricasRoute
  '/forgot-password': typeof PublicForgotPasswordRoute
  '/sign-in': typeof PublicSignInRoute
  '/sign-up': typeof PublicSignUpRoute
  '/two-factor-authentication': typeof PublicTwoFactorAuthenticationRoute
  '/answer/$surveyId': typeof openAnswerSurveyIdRoute
  '/administrator': typeof ProtectedadminAdministratorRoute
  '/company': typeof ProtectedadminCompanyRouteWithChildren
  '/questions': typeof ProtectedadminQuestionsRoute
  '/themes': typeof ProtectedadminThemesRoute
  '/user': typeof ProtectedadminUserRouteWithChildren
  '/project-reports/$projectId': typeof ProtectedProjectReportsProjectIdRoute
  '/projects/$projectId': typeof ProtectedProjectsProjectIdRoute
  '/reset-password/$resetPasswordAccessToken': typeof PublicResetPasswordResetPasswordAccessTokenRoute
  '/sign-in/email': typeof PublicSignInEmailRoute
  '/list-projects/$companyId': typeof ProtectedadminListProjectsCompanyIdRoute
  '/members/$companyId': typeof ProtectedadminMembersCompanyIdRoute
  '/new-project/$id': typeof ProtectedadminNewProjectIdRoute
  '/question/new': typeof ProtectedadminQuestionNewRoute
  '/theme/new': typeof ProtectedadminThemeNewRoute
  '/answer/$surveyId/preview': typeof ProtectedAnswerSurveyIdPreviewRoute
  '/auth/provider/complete': typeof PublicAuthProviderCompleteRoute
  '/sign-in/email/code': typeof PublicSignInEmailCodeRoute
  '/company/detail/$id': typeof ProtectedadminCompanyDetailIdRoute
  '/projects/$projectId/$companyId': typeof ProtectedadminProjectsProjectIdCompanyIdRoute
  '/question/detail/$questionId': typeof ProtectedadminQuestionDetailQuestionIdRoute
  '/theme/$themeId/models': typeof ProtectedadminThemeThemeIdModelsRouteWithChildren
  '/theme/detail/$themeId': typeof ProtectedadminThemeDetailThemeIdRoute
  '/user/detail/$id': typeof ProtectedadminUserDetailIdRoute
  '/theme/$themeId/models/new': typeof ProtectedadminThemeThemeIdModelsNewRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/403': typeof open403Route
  '/404': typeof open404Route
  '/500': typeof open500Route
  '/company-invitation': typeof openCompanyInvitationRoute
  '/preview-access-denied': typeof openPreviewAccessDeniedRoute
  '/account': typeof ProtectedAccountRoute
  '/help': typeof ProtectedHelpRoute
  '/home': typeof ProtectedHomeRoute
  '/members': typeof ProtectedMembersRoute
  '/my-projects': typeof ProtectedMyProjectsRoute
  '/oficinas3r': typeof ProtectedOficinas3rRoute
  '/onboarding': typeof ProtectedOnboardingRoute
  '/sla': typeof ProtectedSlaRoute
  '/trilha-de-metricas': typeof ProtectedTrilhaDeMetricasRoute
  '/forgot-password': typeof PublicForgotPasswordRoute
  '/sign-in': typeof PublicSignInRoute
  '/sign-up': typeof PublicSignUpRoute
  '/two-factor-authentication': typeof PublicTwoFactorAuthenticationRoute
  '/answer/$surveyId': typeof openAnswerSurveyIdRoute
  '/administrator': typeof ProtectedadminAdministratorRoute
  '/company': typeof ProtectedadminCompanyRouteWithChildren
  '/questions': typeof ProtectedadminQuestionsRoute
  '/themes': typeof ProtectedadminThemesRoute
  '/user': typeof ProtectedadminUserRouteWithChildren
  '/project-reports/$projectId': typeof ProtectedProjectReportsProjectIdRoute
  '/projects/$projectId': typeof ProtectedProjectsProjectIdRoute
  '/reset-password/$resetPasswordAccessToken': typeof PublicResetPasswordResetPasswordAccessTokenRoute
  '/sign-in/email': typeof PublicSignInEmailRoute
  '/list-projects/$companyId': typeof ProtectedadminListProjectsCompanyIdRoute
  '/members/$companyId': typeof ProtectedadminMembersCompanyIdRoute
  '/new-project/$id': typeof ProtectedadminNewProjectIdRoute
  '/question/new': typeof ProtectedadminQuestionNewRoute
  '/theme/new': typeof ProtectedadminThemeNewRoute
  '/answer/$surveyId/preview': typeof ProtectedAnswerSurveyIdPreviewRoute
  '/auth/provider/complete': typeof PublicAuthProviderCompleteRoute
  '/sign-in/email/code': typeof PublicSignInEmailCodeRoute
  '/company/detail/$id': typeof ProtectedadminCompanyDetailIdRoute
  '/projects/$projectId/$companyId': typeof ProtectedadminProjectsProjectIdCompanyIdRoute
  '/question/detail/$questionId': typeof ProtectedadminQuestionDetailQuestionIdRoute
  '/theme/$themeId/models': typeof ProtectedadminThemeThemeIdModelsRouteWithChildren
  '/theme/detail/$themeId': typeof ProtectedadminThemeDetailThemeIdRoute
  '/user/detail/$id': typeof ProtectedadminUserDetailIdRoute
  '/theme/$themeId/models/new': typeof ProtectedadminThemeThemeIdModelsNewRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/_protected': typeof ProtectedRouteWithChildren
  '/_public': typeof PublicRouteWithChildren
  '/(open)/403': typeof open403Route
  '/(open)/404': typeof open404Route
  '/(open)/500': typeof open500Route
  '/(open)/company-invitation': typeof openCompanyInvitationRoute
  '/(open)/preview-access-denied': typeof openPreviewAccessDeniedRoute
  '/_protected/account': typeof ProtectedAccountRoute
  '/_protected/help': typeof ProtectedHelpRoute
  '/_protected/home': typeof ProtectedHomeRoute
  '/_protected/members': typeof ProtectedMembersRoute
  '/_protected/my-projects': typeof ProtectedMyProjectsRoute
  '/_protected/oficinas3r': typeof ProtectedOficinas3rRoute
  '/_protected/onboarding': typeof ProtectedOnboardingRoute
  '/_protected/sla': typeof ProtectedSlaRoute
  '/_protected/trilha-de-metricas': typeof ProtectedTrilhaDeMetricasRoute
  '/_public/forgot-password': typeof PublicForgotPasswordRoute
  '/_public/sign-in': typeof PublicSignInRoute
  '/_public/sign-up': typeof PublicSignUpRoute
  '/_public/two-factor-authentication': typeof PublicTwoFactorAuthenticationRoute
  '/(open)/answer/$surveyId': typeof openAnswerSurveyIdRoute
  '/_protected/(admin)/administrator': typeof ProtectedadminAdministratorRoute
  '/_protected/(admin)/company': typeof ProtectedadminCompanyRouteWithChildren
  '/_protected/(admin)/questions': typeof ProtectedadminQuestionsRoute
  '/_protected/(admin)/themes': typeof ProtectedadminThemesRoute
  '/_protected/(admin)/user': typeof ProtectedadminUserRouteWithChildren
  '/_protected/project-reports/$projectId': typeof ProtectedProjectReportsProjectIdRoute
  '/_protected/projects/$projectId': typeof ProtectedProjectsProjectIdRoute
  '/_public/reset-password/$resetPasswordAccessToken': typeof PublicResetPasswordResetPasswordAccessTokenRoute
  '/_public/sign-in_/email': typeof PublicSignInEmailRoute
  '/_protected/(admin)/list-projects/$companyId': typeof ProtectedadminListProjectsCompanyIdRoute
  '/_protected/(admin)/members/$companyId': typeof ProtectedadminMembersCompanyIdRoute
  '/_protected/(admin)/new-project/$id': typeof ProtectedadminNewProjectIdRoute
  '/_protected/(admin)/question/new': typeof ProtectedadminQuestionNewRoute
  '/_protected/(admin)/theme/new': typeof ProtectedadminThemeNewRoute
  '/_protected/answer/$surveyId/preview': typeof ProtectedAnswerSurveyIdPreviewRoute
  '/_public/auth/provider/complete': typeof PublicAuthProviderCompleteRoute
  '/_public/sign-in_/email_/code': typeof PublicSignInEmailCodeRoute
  '/_protected/(admin)/company/detail/$id': typeof ProtectedadminCompanyDetailIdRoute
  '/_protected/(admin)/projects/$projectId/$companyId': typeof ProtectedadminProjectsProjectIdCompanyIdRoute
  '/_protected/(admin)/question/detail/$questionId': typeof ProtectedadminQuestionDetailQuestionIdRoute
  '/_protected/(admin)/theme/$themeId/models': typeof ProtectedadminThemeThemeIdModelsRouteWithChildren
  '/_protected/(admin)/theme/detail/$themeId': typeof ProtectedadminThemeDetailThemeIdRoute
  '/_protected/(admin)/user/detail/$id': typeof ProtectedadminUserDetailIdRoute
  '/_protected/(admin)/theme/$themeId/models/new': typeof ProtectedadminThemeThemeIdModelsNewRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$'
    | '/403'
    | '/404'
    | '/500'
    | '/company-invitation'
    | '/preview-access-denied'
    | '/account'
    | '/help'
    | '/home'
    | '/members'
    | '/my-projects'
    | '/oficinas3r'
    | '/onboarding'
    | '/sla'
    | '/trilha-de-metricas'
    | '/forgot-password'
    | '/sign-in'
    | '/sign-up'
    | '/two-factor-authentication'
    | '/answer/$surveyId'
    | '/administrator'
    | '/company'
    | '/questions'
    | '/themes'
    | '/user'
    | '/project-reports/$projectId'
    | '/projects/$projectId'
    | '/reset-password/$resetPasswordAccessToken'
    | '/sign-in/email'
    | '/list-projects/$companyId'
    | '/members/$companyId'
    | '/new-project/$id'
    | '/question/new'
    | '/theme/new'
    | '/answer/$surveyId/preview'
    | '/auth/provider/complete'
    | '/sign-in/email/code'
    | '/company/detail/$id'
    | '/projects/$projectId/$companyId'
    | '/question/detail/$questionId'
    | '/theme/$themeId/models'
    | '/theme/detail/$themeId'
    | '/user/detail/$id'
    | '/theme/$themeId/models/new'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$'
    | '/403'
    | '/404'
    | '/500'
    | '/company-invitation'
    | '/preview-access-denied'
    | '/account'
    | '/help'
    | '/home'
    | '/members'
    | '/my-projects'
    | '/oficinas3r'
    | '/onboarding'
    | '/sla'
    | '/trilha-de-metricas'
    | '/forgot-password'
    | '/sign-in'
    | '/sign-up'
    | '/two-factor-authentication'
    | '/answer/$surveyId'
    | '/administrator'
    | '/company'
    | '/questions'
    | '/themes'
    | '/user'
    | '/project-reports/$projectId'
    | '/projects/$projectId'
    | '/reset-password/$resetPasswordAccessToken'
    | '/sign-in/email'
    | '/list-projects/$companyId'
    | '/members/$companyId'
    | '/new-project/$id'
    | '/question/new'
    | '/theme/new'
    | '/answer/$surveyId/preview'
    | '/auth/provider/complete'
    | '/sign-in/email/code'
    | '/company/detail/$id'
    | '/projects/$projectId/$companyId'
    | '/question/detail/$questionId'
    | '/theme/$themeId/models'
    | '/theme/detail/$themeId'
    | '/user/detail/$id'
    | '/theme/$themeId/models/new'
  id:
    | '__root__'
    | '/'
    | '/$'
    | '/_protected'
    | '/_public'
    | '/(open)/403'
    | '/(open)/404'
    | '/(open)/500'
    | '/(open)/company-invitation'
    | '/(open)/preview-access-denied'
    | '/_protected/account'
    | '/_protected/help'
    | '/_protected/home'
    | '/_protected/members'
    | '/_protected/my-projects'
    | '/_protected/oficinas3r'
    | '/_protected/onboarding'
    | '/_protected/sla'
    | '/_protected/trilha-de-metricas'
    | '/_public/forgot-password'
    | '/_public/sign-in'
    | '/_public/sign-up'
    | '/_public/two-factor-authentication'
    | '/(open)/answer/$surveyId'
    | '/_protected/(admin)/administrator'
    | '/_protected/(admin)/company'
    | '/_protected/(admin)/questions'
    | '/_protected/(admin)/themes'
    | '/_protected/(admin)/user'
    | '/_protected/project-reports/$projectId'
    | '/_protected/projects/$projectId'
    | '/_public/reset-password/$resetPasswordAccessToken'
    | '/_public/sign-in_/email'
    | '/_protected/(admin)/list-projects/$companyId'
    | '/_protected/(admin)/members/$companyId'
    | '/_protected/(admin)/new-project/$id'
    | '/_protected/(admin)/question/new'
    | '/_protected/(admin)/theme/new'
    | '/_protected/answer/$surveyId/preview'
    | '/_public/auth/provider/complete'
    | '/_public/sign-in_/email_/code'
    | '/_protected/(admin)/company/detail/$id'
    | '/_protected/(admin)/projects/$projectId/$companyId'
    | '/_protected/(admin)/question/detail/$questionId'
    | '/_protected/(admin)/theme/$themeId/models'
    | '/_protected/(admin)/theme/detail/$themeId'
    | '/_protected/(admin)/user/detail/$id'
    | '/_protected/(admin)/theme/$themeId/models/new'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  SplatRoute: typeof SplatRoute
  ProtectedRoute: typeof ProtectedRouteWithChildren
  PublicRoute: typeof PublicRouteWithChildren
  open403Route: typeof open403Route
  open404Route: typeof open404Route
  open500Route: typeof open500Route
  openCompanyInvitationRoute: typeof openCompanyInvitationRoute
  openPreviewAccessDeniedRoute: typeof openPreviewAccessDeniedRoute
  openAnswerSurveyIdRoute: typeof openAnswerSurveyIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$': {
      id: '/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof SplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_protected': {
      id: '/_protected'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ProtectedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(open)/403': {
      id: '/(open)/403'
      path: '/403'
      fullPath: '/403'
      preLoaderRoute: typeof open403RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(open)/404': {
      id: '/(open)/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof open404RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(open)/500': {
      id: '/(open)/500'
      path: '/500'
      fullPath: '/500'
      preLoaderRoute: typeof open500RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(open)/company-invitation': {
      id: '/(open)/company-invitation'
      path: '/company-invitation'
      fullPath: '/company-invitation'
      preLoaderRoute: typeof openCompanyInvitationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(open)/preview-access-denied': {
      id: '/(open)/preview-access-denied'
      path: '/preview-access-denied'
      fullPath: '/preview-access-denied'
      preLoaderRoute: typeof openPreviewAccessDeniedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_protected/account': {
      id: '/_protected/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof ProtectedAccountRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/help': {
      id: '/_protected/help'
      path: '/help'
      fullPath: '/help'
      preLoaderRoute: typeof ProtectedHelpRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/home': {
      id: '/_protected/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof ProtectedHomeRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/members': {
      id: '/_protected/members'
      path: '/members'
      fullPath: '/members'
      preLoaderRoute: typeof ProtectedMembersRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/my-projects': {
      id: '/_protected/my-projects'
      path: '/my-projects'
      fullPath: '/my-projects'
      preLoaderRoute: typeof ProtectedMyProjectsRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/oficinas3r': {
      id: '/_protected/oficinas3r'
      path: '/oficinas3r'
      fullPath: '/oficinas3r'
      preLoaderRoute: typeof ProtectedOficinas3rRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/onboarding': {
      id: '/_protected/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof ProtectedOnboardingRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/sla': {
      id: '/_protected/sla'
      path: '/sla'
      fullPath: '/sla'
      preLoaderRoute: typeof ProtectedSlaRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/trilha-de-metricas': {
      id: '/_protected/trilha-de-metricas'
      path: '/trilha-de-metricas'
      fullPath: '/trilha-de-metricas'
      preLoaderRoute: typeof ProtectedTrilhaDeMetricasRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_public/forgot-password': {
      id: '/_public/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof PublicForgotPasswordRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/sign-in': {
      id: '/_public/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof PublicSignInRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/sign-up': {
      id: '/_public/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof PublicSignUpRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/two-factor-authentication': {
      id: '/_public/two-factor-authentication'
      path: '/two-factor-authentication'
      fullPath: '/two-factor-authentication'
      preLoaderRoute: typeof PublicTwoFactorAuthenticationRouteImport
      parentRoute: typeof PublicRoute
    }
    '/(open)/answer/$surveyId': {
      id: '/(open)/answer/$surveyId'
      path: '/answer/$surveyId'
      fullPath: '/answer/$surveyId'
      preLoaderRoute: typeof openAnswerSurveyIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_protected/(admin)/administrator': {
      id: '/_protected/(admin)/administrator'
      path: '/administrator'
      fullPath: '/administrator'
      preLoaderRoute: typeof ProtectedadminAdministratorRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/(admin)/company': {
      id: '/_protected/(admin)/company'
      path: '/company'
      fullPath: '/company'
      preLoaderRoute: typeof ProtectedadminCompanyRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/(admin)/questions': {
      id: '/_protected/(admin)/questions'
      path: '/questions'
      fullPath: '/questions'
      preLoaderRoute: typeof ProtectedadminQuestionsRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/(admin)/themes': {
      id: '/_protected/(admin)/themes'
      path: '/themes'
      fullPath: '/themes'
      preLoaderRoute: typeof ProtectedadminThemesRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/(admin)/user': {
      id: '/_protected/(admin)/user'
      path: '/user'
      fullPath: '/user'
      preLoaderRoute: typeof ProtectedadminUserRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/project-reports/$projectId': {
      id: '/_protected/project-reports/$projectId'
      path: '/project-reports/$projectId'
      fullPath: '/project-reports/$projectId'
      preLoaderRoute: typeof ProtectedProjectReportsProjectIdRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/projects/$projectId': {
      id: '/_protected/projects/$projectId'
      path: '/projects/$projectId'
      fullPath: '/projects/$projectId'
      preLoaderRoute: typeof ProtectedProjectsProjectIdRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_public/reset-password/$resetPasswordAccessToken': {
      id: '/_public/reset-password/$resetPasswordAccessToken'
      path: '/reset-password/$resetPasswordAccessToken'
      fullPath: '/reset-password/$resetPasswordAccessToken'
      preLoaderRoute: typeof PublicResetPasswordResetPasswordAccessTokenRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/sign-in_/email': {
      id: '/_public/sign-in_/email'
      path: '/sign-in/email'
      fullPath: '/sign-in/email'
      preLoaderRoute: typeof PublicSignInEmailRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_protected/(admin)/list-projects/$companyId': {
      id: '/_protected/(admin)/list-projects/$companyId'
      path: '/list-projects/$companyId'
      fullPath: '/list-projects/$companyId'
      preLoaderRoute: typeof ProtectedadminListProjectsCompanyIdRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/(admin)/members/$companyId': {
      id: '/_protected/(admin)/members/$companyId'
      path: '/members/$companyId'
      fullPath: '/members/$companyId'
      preLoaderRoute: typeof ProtectedadminMembersCompanyIdRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/(admin)/new-project/$id': {
      id: '/_protected/(admin)/new-project/$id'
      path: '/new-project/$id'
      fullPath: '/new-project/$id'
      preLoaderRoute: typeof ProtectedadminNewProjectIdRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/(admin)/question/new': {
      id: '/_protected/(admin)/question/new'
      path: '/question/new'
      fullPath: '/question/new'
      preLoaderRoute: typeof ProtectedadminQuestionNewRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/(admin)/theme/new': {
      id: '/_protected/(admin)/theme/new'
      path: '/theme/new'
      fullPath: '/theme/new'
      preLoaderRoute: typeof ProtectedadminThemeNewRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/answer/$surveyId/preview': {
      id: '/_protected/answer/$surveyId/preview'
      path: '/answer/$surveyId/preview'
      fullPath: '/answer/$surveyId/preview'
      preLoaderRoute: typeof ProtectedAnswerSurveyIdPreviewRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_public/auth/provider/complete': {
      id: '/_public/auth/provider/complete'
      path: '/auth/provider/complete'
      fullPath: '/auth/provider/complete'
      preLoaderRoute: typeof PublicAuthProviderCompleteRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/sign-in_/email_/code': {
      id: '/_public/sign-in_/email_/code'
      path: '/sign-in/email/code'
      fullPath: '/sign-in/email/code'
      preLoaderRoute: typeof PublicSignInEmailCodeRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_protected/(admin)/company/detail/$id': {
      id: '/_protected/(admin)/company/detail/$id'
      path: '/detail/$id'
      fullPath: '/company/detail/$id'
      preLoaderRoute: typeof ProtectedadminCompanyDetailIdRouteImport
      parentRoute: typeof ProtectedadminCompanyRoute
    }
    '/_protected/(admin)/projects/$projectId/$companyId': {
      id: '/_protected/(admin)/projects/$projectId/$companyId'
      path: '/projects/$projectId/$companyId'
      fullPath: '/projects/$projectId/$companyId'
      preLoaderRoute: typeof ProtectedadminProjectsProjectIdCompanyIdRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/(admin)/question/detail/$questionId': {
      id: '/_protected/(admin)/question/detail/$questionId'
      path: '/question/detail/$questionId'
      fullPath: '/question/detail/$questionId'
      preLoaderRoute: typeof ProtectedadminQuestionDetailQuestionIdRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/(admin)/theme/$themeId/models': {
      id: '/_protected/(admin)/theme/$themeId/models'
      path: '/theme/$themeId/models'
      fullPath: '/theme/$themeId/models'
      preLoaderRoute: typeof ProtectedadminThemeThemeIdModelsRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/(admin)/theme/detail/$themeId': {
      id: '/_protected/(admin)/theme/detail/$themeId'
      path: '/theme/detail/$themeId'
      fullPath: '/theme/detail/$themeId'
      preLoaderRoute: typeof ProtectedadminThemeDetailThemeIdRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/(admin)/user/detail/$id': {
      id: '/_protected/(admin)/user/detail/$id'
      path: '/detail/$id'
      fullPath: '/user/detail/$id'
      preLoaderRoute: typeof ProtectedadminUserDetailIdRouteImport
      parentRoute: typeof ProtectedadminUserRoute
    }
    '/_protected/(admin)/theme/$themeId/models/new': {
      id: '/_protected/(admin)/theme/$themeId/models/new'
      path: '/new'
      fullPath: '/theme/$themeId/models/new'
      preLoaderRoute: typeof ProtectedadminThemeThemeIdModelsNewRouteImport
      parentRoute: typeof ProtectedadminThemeThemeIdModelsRoute
    }
  }
}

interface ProtectedadminCompanyRouteChildren {
  ProtectedadminCompanyDetailIdRoute: typeof ProtectedadminCompanyDetailIdRoute
}

const ProtectedadminCompanyRouteChildren: ProtectedadminCompanyRouteChildren = {
  ProtectedadminCompanyDetailIdRoute: ProtectedadminCompanyDetailIdRoute,
}

const ProtectedadminCompanyRouteWithChildren =
  ProtectedadminCompanyRoute._addFileChildren(
    ProtectedadminCompanyRouteChildren,
  )

interface ProtectedadminUserRouteChildren {
  ProtectedadminUserDetailIdRoute: typeof ProtectedadminUserDetailIdRoute
}

const ProtectedadminUserRouteChildren: ProtectedadminUserRouteChildren = {
  ProtectedadminUserDetailIdRoute: ProtectedadminUserDetailIdRoute,
}

const ProtectedadminUserRouteWithChildren =
  ProtectedadminUserRoute._addFileChildren(ProtectedadminUserRouteChildren)

interface ProtectedadminThemeThemeIdModelsRouteChildren {
  ProtectedadminThemeThemeIdModelsNewRoute: typeof ProtectedadminThemeThemeIdModelsNewRoute
}

const ProtectedadminThemeThemeIdModelsRouteChildren: ProtectedadminThemeThemeIdModelsRouteChildren =
  {
    ProtectedadminThemeThemeIdModelsNewRoute:
      ProtectedadminThemeThemeIdModelsNewRoute,
  }

const ProtectedadminThemeThemeIdModelsRouteWithChildren =
  ProtectedadminThemeThemeIdModelsRoute._addFileChildren(
    ProtectedadminThemeThemeIdModelsRouteChildren,
  )

interface ProtectedRouteChildren {
  ProtectedAccountRoute: typeof ProtectedAccountRoute
  ProtectedHelpRoute: typeof ProtectedHelpRoute
  ProtectedHomeRoute: typeof ProtectedHomeRoute
  ProtectedMembersRoute: typeof ProtectedMembersRoute
  ProtectedMyProjectsRoute: typeof ProtectedMyProjectsRoute
  ProtectedOficinas3rRoute: typeof ProtectedOficinas3rRoute
  ProtectedOnboardingRoute: typeof ProtectedOnboardingRoute
  ProtectedSlaRoute: typeof ProtectedSlaRoute
  ProtectedTrilhaDeMetricasRoute: typeof ProtectedTrilhaDeMetricasRoute
  ProtectedadminAdministratorRoute: typeof ProtectedadminAdministratorRoute
  ProtectedadminCompanyRoute: typeof ProtectedadminCompanyRouteWithChildren
  ProtectedadminQuestionsRoute: typeof ProtectedadminQuestionsRoute
  ProtectedadminThemesRoute: typeof ProtectedadminThemesRoute
  ProtectedadminUserRoute: typeof ProtectedadminUserRouteWithChildren
  ProtectedProjectReportsProjectIdRoute: typeof ProtectedProjectReportsProjectIdRoute
  ProtectedProjectsProjectIdRoute: typeof ProtectedProjectsProjectIdRoute
  ProtectedadminListProjectsCompanyIdRoute: typeof ProtectedadminListProjectsCompanyIdRoute
  ProtectedadminMembersCompanyIdRoute: typeof ProtectedadminMembersCompanyIdRoute
  ProtectedadminNewProjectIdRoute: typeof ProtectedadminNewProjectIdRoute
  ProtectedadminQuestionNewRoute: typeof ProtectedadminQuestionNewRoute
  ProtectedadminThemeNewRoute: typeof ProtectedadminThemeNewRoute
  ProtectedAnswerSurveyIdPreviewRoute: typeof ProtectedAnswerSurveyIdPreviewRoute
  ProtectedadminProjectsProjectIdCompanyIdRoute: typeof ProtectedadminProjectsProjectIdCompanyIdRoute
  ProtectedadminQuestionDetailQuestionIdRoute: typeof ProtectedadminQuestionDetailQuestionIdRoute
  ProtectedadminThemeThemeIdModelsRoute: typeof ProtectedadminThemeThemeIdModelsRouteWithChildren
  ProtectedadminThemeDetailThemeIdRoute: typeof ProtectedadminThemeDetailThemeIdRoute
}

const ProtectedRouteChildren: ProtectedRouteChildren = {
  ProtectedAccountRoute: ProtectedAccountRoute,
  ProtectedHelpRoute: ProtectedHelpRoute,
  ProtectedHomeRoute: ProtectedHomeRoute,
  ProtectedMembersRoute: ProtectedMembersRoute,
  ProtectedMyProjectsRoute: ProtectedMyProjectsRoute,
  ProtectedOficinas3rRoute: ProtectedOficinas3rRoute,
  ProtectedOnboardingRoute: ProtectedOnboardingRoute,
  ProtectedSlaRoute: ProtectedSlaRoute,
  ProtectedTrilhaDeMetricasRoute: ProtectedTrilhaDeMetricasRoute,
  ProtectedadminAdministratorRoute: ProtectedadminAdministratorRoute,
  ProtectedadminCompanyRoute: ProtectedadminCompanyRouteWithChildren,
  ProtectedadminQuestionsRoute: ProtectedadminQuestionsRoute,
  ProtectedadminThemesRoute: ProtectedadminThemesRoute,
  ProtectedadminUserRoute: ProtectedadminUserRouteWithChildren,
  ProtectedProjectReportsProjectIdRoute: ProtectedProjectReportsProjectIdRoute,
  ProtectedProjectsProjectIdRoute: ProtectedProjectsProjectIdRoute,
  ProtectedadminListProjectsCompanyIdRoute:
    ProtectedadminListProjectsCompanyIdRoute,
  ProtectedadminMembersCompanyIdRoute: ProtectedadminMembersCompanyIdRoute,
  ProtectedadminNewProjectIdRoute: ProtectedadminNewProjectIdRoute,
  ProtectedadminQuestionNewRoute: ProtectedadminQuestionNewRoute,
  ProtectedadminThemeNewRoute: ProtectedadminThemeNewRoute,
  ProtectedAnswerSurveyIdPreviewRoute: ProtectedAnswerSurveyIdPreviewRoute,
  ProtectedadminProjectsProjectIdCompanyIdRoute:
    ProtectedadminProjectsProjectIdCompanyIdRoute,
  ProtectedadminQuestionDetailQuestionIdRoute:
    ProtectedadminQuestionDetailQuestionIdRoute,
  ProtectedadminThemeThemeIdModelsRoute:
    ProtectedadminThemeThemeIdModelsRouteWithChildren,
  ProtectedadminThemeDetailThemeIdRoute: ProtectedadminThemeDetailThemeIdRoute,
}

const ProtectedRouteWithChildren = ProtectedRoute._addFileChildren(
  ProtectedRouteChildren,
)

interface PublicRouteChildren {
  PublicForgotPasswordRoute: typeof PublicForgotPasswordRoute
  PublicSignInRoute: typeof PublicSignInRoute
  PublicSignUpRoute: typeof PublicSignUpRoute
  PublicTwoFactorAuthenticationRoute: typeof PublicTwoFactorAuthenticationRoute
  PublicResetPasswordResetPasswordAccessTokenRoute: typeof PublicResetPasswordResetPasswordAccessTokenRoute
  PublicSignInEmailRoute: typeof PublicSignInEmailRoute
  PublicAuthProviderCompleteRoute: typeof PublicAuthProviderCompleteRoute
  PublicSignInEmailCodeRoute: typeof PublicSignInEmailCodeRoute
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicForgotPasswordRoute: PublicForgotPasswordRoute,
  PublicSignInRoute: PublicSignInRoute,
  PublicSignUpRoute: PublicSignUpRoute,
  PublicTwoFactorAuthenticationRoute: PublicTwoFactorAuthenticationRoute,
  PublicResetPasswordResetPasswordAccessTokenRoute:
    PublicResetPasswordResetPasswordAccessTokenRoute,
  PublicSignInEmailRoute: PublicSignInEmailRoute,
  PublicAuthProviderCompleteRoute: PublicAuthProviderCompleteRoute,
  PublicSignInEmailCodeRoute: PublicSignInEmailCodeRoute,
}

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  SplatRoute: SplatRoute,
  ProtectedRoute: ProtectedRouteWithChildren,
  PublicRoute: PublicRouteWithChildren,
  open403Route: open403Route,
  open404Route: open404Route,
  open500Route: open500Route,
  openCompanyInvitationRoute: openCompanyInvitationRoute,
  openPreviewAccessDeniedRoute: openPreviewAccessDeniedRoute,
  openAnswerSurveyIdRoute: openAnswerSurveyIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
